import ExpandMore from '@mui/icons-material/ExpandMore'
import {
  Button,
  Typography,
  MenuItem,
  ListSubheader,
  ListItemText,
  Divider,
  Menu,
  ListItemAvatar,
  Avatar,
} from '@mui/material'
import I18n from 'i18n-js'
import PropTypes from 'prop-types'
import { createRef, PureComponent } from 'react'

import Analytics from '../../../../analytics/Analytics'
import { connect, selectors, actions } from '../../../../stores'
import LegacySvg from '../../LegacySvg'

const RetailerAccount = (props) => {
  return (
    <MenuItem dense={false} onClick={props.onClick} divider>
      <ListItemAvatar>
        <Avatar variant={'square'} style={{ backgroundColor: 'transparent' }}>
          {props.logo && (
            <img
              alt={props.name}
              style={{
                width: '100%',
                height: '3rem',
                objectFit: 'contain',
                verticalAlign: 'middle',
              }}
              src={props.logo}
            />
          )}
          {!props.logo && (
            <LegacySvg
              height={'30px'}
              symbol={'retailer-house'}
              width={'30px'}
            />
          )}
        </Avatar>
      </ListItemAvatar>
      <ListItemText primary={props.name} />
    </MenuItem>
  )
}

RetailerAccount.propTypes = {
  logo: PropTypes.string,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

export class RetailerAccountDropdown extends PureComponent {
  constructor(props) {
    super(props)
    this.name = this.constructor.name
    this.anchor = createRef()
    this.state = {
      showMenu: false,
    }
  }

  toggleDropdown() {
    this.setState({ showMenu: !this.state.showMenu })
  }
  setSelectedRetailerAccount(payload) {
    Analytics.track('Retailer Account Select', {
      retailerAccountId: payload.id,
    })
    this.props.setSelectedRetailerAccount(payload)
    this.toggleDropdown()
  }
  renderRetailers() {
    return this.props.dropdownData.map((retailer) => {
      const payload = { id: retailer.id }
      return (
        <RetailerAccount
          key={retailer.id}
          logo={retailer.logo}
          name={retailer.name}
          onClick={() => this.setSelectedRetailerAccount(payload)}
        />
      )
    })
  }

  render() {
    return (
      <div
        style={{ flex: '0 1 auto', display: 'flex', minWidth: '5rem' }}
        ref={this.anchor}
      >
        <Button
          cursor="pointer"
          data-testid={`${this.name}-Brand`}
          onClick={() => this.props.dropdownData && this.toggleDropdown()}
          color="inherit"
          aria-haspopup="true"
          aria-controls={`${this.name}-Popover`}
          endIcon={
            this.props.dropdownData && (
              <ExpandMore
                data-testid={`${this.name}-Expand`}
                fontSize="large"
                color="inherit"
              />
            )
          }
        >
          <Typography
            noWrap
            style={{ textTransform: 'uppercase', color: this.props.brandColor }}
          >
            {this.props.name || I18n.t('nav.noRetailerSelected')}
          </Typography>
        </Button>
        <Menu
          id={`${this.name}-Popover`}
          open={this.state.showMenu}
          anchorEl={this.anchor.current}
          MenuListProps={{
            autoFocus: true,
          }}
          onClose={() => this.toggleDropdown()}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          PaperProps={{
            style: {
              width: 320,
            },
          }}
        >
          <ListSubheader aria-disabled="true" disableSticky>
            {I18n.t('nav.selectABusiness')}
          </ListSubheader>
          <Divider aria-disabled="true" />
          {this.renderRetailers()}
        </Menu>
      </div>
    )
  }
}

RetailerAccountDropdown.propTypes = {
  brandColor: PropTypes.string,
  dropdownData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      logo: PropTypes.string,
    }),
  ),
  name: PropTypes.string,
  setSelectedRetailerAccount: PropTypes.func.isRequired,
}

RetailerAccountDropdown.defaultProps = {
  dropdownData: [],
}

const mapStateToProps = (state) => ({
  ...selectors.mainMenu.selectRetailerAccountsDropdownData(state),
  ...selectors.mainMenu.selectCurrentRetailerAccountNameSlug(state),
})

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedRetailerAccount: (payload) =>
      dispatch(actions.app.selectRetailerAccount(payload)),
  }
}

const ConnectedRetailerAccountDropdown = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RetailerAccountDropdown)

export default ConnectedRetailerAccountDropdown
